"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Weather = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Weather_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6a4.488 4.488 0 0 1-1.468 3.325C15.41 9.802 16 10.7 16 11.73c0 1.53-1.302 2.769-2.91 2.769H2.91C1.301 14.5 0 13.26 0 11.73c0-1.306.95-2.401 2.23-2.692C2.542 7.036 4.355 5.5 6.545 5.5c.162 0 .322.008.48.025A4.5 4.5 0 0 1 16 6Zm-3.165 3.237a1.007 1.007 0 0 1-.017-.275c0-.932-.807-1.77-1.909-1.77-.358 0-.688.09-.97.245a1 1 0 0 1-1.13-.116 3.385 3.385 0 0 0-.703-.462 3.49 3.49 0 0 0-1.56-.359c-1.727 0-3.096 1.205-3.328 2.692a1 1 0 0 1-.766.82C1.586 10.21 1 10.932 1 11.731c0 .931.808 1.769 1.91 1.769h10.18c1.102 0 1.91-.838 1.91-1.77 0-.788-.571-1.503-1.42-1.71l-.008-.002a1 1 0 0 1-.738-.781Zm-1.926-3.045c1.492 0 2.722 1.07 2.89 2.447a3.5 3.5 0 1 0-5.79-2.9c.54.184 1.031.465 1.45.822a3.009 3.009 0 0 1 1.45-.369Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Weather_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Weather;
exports["default"] = _default;